import {
  getDataSourceSupportedInputs,
  DataSourceType,
} from "@syla/shared/types/models/DataSourceBase";
import { DataSourceWithNetworks } from "@syla/shared/types/responses/DataSourceWithNetworks";
import { DataSourceInputType } from "../../../../helper/dataSource/DataSourceInputType";
import { ImportMethod } from "../panels/ImportMethodSelectionPanel";

export function getSupportedImportMethods(
  dataSource: DataSourceWithNetworks,
): ImportMethod[] {
  const supportedMethods = getDataSourceSupportedInputs(dataSource);

  const methods: ImportMethod[] = [];

  if (supportedMethods.sync) {
    methods.push(DataSourceInputType.Api);
  }

  if (supportedMethods.file) {
    methods.push(DataSourceInputType.Csv);
  }

  if (dataSource.type !== DataSourceType.Import) {
    methods.push(DataSourceInputType.Custom);
    methods.push("Empty");
  }

  return methods;
}
